import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {COLOURS} from "./Colours";
import {Style} from "ol/style";

export class OutlierLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(5, COLOURS.CORBETT.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(
        5,
        COLOURS.CORBETT.UNVISITED
    );

    getProgressElement(): HTMLDivElement {
        return document.getElementById("progress-outlier") as HTMLDivElement;
    }

    getCountElement(): HTMLDivElement {
        return document.getElementById("count-outlier") as HTMLDivElement;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hills: HillLists): Hill[] {
        return hills.lakes.filter((h) =>
            h.categories.includes("WAINWRIGHT_OUTLIER")
        );
    }

    getName(): string {
        return "Outliers";
    }
}
